export const loadEvent = () => {
  try {
    return Turbolinks.supported ? "turbolinks:load" : "DOMContentLoaded";
  } catch {
    return "DOMContentLoaded";
  }
};
